import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ContactInterface } from '@app/interfaces/contact.interface';

export function marriageVsApplicantCount(getApplicantsCount: () => number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const familyStatus: string = control.value;
        const apllicantCount: number = getApplicantsCount();

        if (familyStatus === 'married' && apllicantCount === 1) {
            return { marriageVsApplicantCount: true };
        }

        return null;
    };
}

export const emailValidator = Validators.pattern(
    '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
);

export function phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control?.value) {
            const pattern = new RegExp('[0-9]{9}');
            const inputValue = control.value;
            const noWhiteSpace = inputValue.replace(/\s/g, '');
            const isValid = pattern.test(noWhiteSpace) && noWhiteSpace.length === 9;
            return isValid ? null : { validPhone: true };
        }
    };
}

export function applicantEmailDuplicityValidator(
    applicants: ContactInterface[],
    currentApplicantId: string
): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const email = control.value;
        if (email) {
            const applicantsWithDuplicitEmails = applicants.filter(
                (applicant) => applicant.email === email && applicant._id !== currentApplicantId
            );
            if (applicantsWithDuplicitEmails.length) {
                return { emailDuplicity: true };
            }
        }

        return null;
    };
}
